// extracted by mini-css-extract-plugin
module.exports = {"backToLatestArticle":"back-to-latest-article_backToLatestArticle__dq733"};